export default function About() {
  return (
    <div className="card-container">
      <div className="card-body" style={{ lineHeight: "2" }}>
        <h3 className="card-title" style={{ fontSize: "22px" }}>
          बिहार स्टेट ओपन ई-स्पोर्ट्स चैंपियनशिप
        </h3>

        <p className="card-text">
          बिहार स्टेट ओपन ई-स्पोर्ट्स चैंपियनशिप के तीसरे संस्करण का आयोजन 4 से
          16 मई 2026 तक किया जा रहा है। प्रतियोगिता के लिए रजिस्ट्रेशन प्रक्रिया
          19 अप्रैल 2026 से शुरू होकर 2 मई 2026 तक चली। टूर्नामेंट में कुल पाँच
          गेम टाइटल्स - BGMI, Chess.com, eFootball Mobile, FC26 और Street
          Fighter 6 को शामिल किया गया, जिनमें कुल 2,182 प्रतिभागियों ने
          रजिस्ट्रेशन कराया। गेम अनुसार भागीदारी में Chess में 1,151, eFootball
          Mobile में 223, FC26 में 162 और Street Fighter 6 में 35 प्रतिभागियों
          ने हिस्सा लिया, वहीं BGMI में कुल 611 टीमों ने रजिस्ट्रेशन कराया,
          जिनमें प्रत्येक टीम में 4 से 5 सदस्य शामिल हैं। प्रतियोगिता के ऑनलाइन
          मुकाबले 4 मई 2026 से शुरू हो चुके हैं, जबकि इसका LAN ग्रैंड फिनाले 16
          मई 2026 को पटना स्थित इंडोर स्टेडियम, पाटलिपुत्र स्पोर्ट्स कॉम्प्लेक्स
          में आयोजित किया जायेगा।
        </p>
        <br />
      </div>
    </div>
  );
}
